import React from 'react';
import { Header, Footer } from '../LandingPage/LandingPage';

const galleryImages = [
  "/staticImages/gallery/img1.jpg",
  "/staticImages/gallery/img2.jpg",
  "/staticImages/gallery/img3.jpg",
  "/staticImages/gallery/img4.jpg",
  "/staticImages/gallery/img5.jpg",
  "/staticImages/gallery/img6.jpg",
  "/staticImages/gallery/img7.jpg",
  "/staticImages/gallery/img8.jpg",
  "/staticImages/gallery/img9.jpg",
  "/staticImages/gallery/img10.jpg",
  "/staticImages/gallery/img11.jpg",
  "/staticImages/gallery/img12.jpg"
  // Add more image paths as needed
];

const GalleryPage = () => {
  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Header />

      <main className="flex-1 py-12 px-6">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-3xl font-bold text-center mb-6">Gallery</h1>
          <p className="text-center text-gray-600 mb-10">Showcasing our products in real environments</p>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
            {galleryImages.map((src, index) => (
              <div
                key={index}
                className="overflow-hidden rounded-xl shadow hover:shadow-md transition"
              >
                <img
                  src={src}
                  alt={`Gradiance product finish ${index + 1}`}
                  className="w-full h-48 object-cover"
                  onError={(e) => (e.target.style.display = 'none')}
                />
              </div>
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default GalleryPage;
